
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
} from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  withEntities,
} from '@ngrx/signals/entities';

import { OrganizationSite } from '../../types';

const _organizationSiteEntityConfig = () =>
  entityConfig({
    collection: '_site',
    entity: type<OrganizationSite>(),
    selectId: (entity) => entity.id,
  });

export const withOrganizationSiteEntities = () => {
  return signalStoreFeature(
    withEntities(_organizationSiteEntityConfig()),
    withMethods(({ ...store }) => ({
      loadSites: (data: OrganizationSite[]) => {
        return patchState(
          store,
          setAllEntities(data, _organizationSiteEntityConfig()),
        );
      },
    })),
  );
};
